function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68.2 22.2",
    style: {
      enableBackground: "new 0 0 68.2 22.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M29.425,11.602h-1.452c-0.008-0.073-0.011-0.126-0.011-0.161 c-0.035-0.44-0.132-0.716-0.293-0.829c-0.16-0.113-0.539-0.169-1.136-0.169c-0.704,0-1.164,0.065-1.38,0.195 c-0.216,0.13-0.324,0.403-0.324,0.82c0,0.493,0.088,0.79,0.264,0.889c0.176,0.1,0.757,0.176,1.744,0.229 c1.166,0.065,1.921,0.232,2.263,0.499c0.342,0.268,0.514,0.824,0.514,1.669c0,1.04-0.201,1.713-0.602,2.016 c-0.402,0.304-1.287,0.456-2.656,0.456c-1.232,0-2.049-0.149-2.453-0.447c-0.404-0.298-0.605-0.903-0.605-1.813l-0.006-0.287 h1.445l0.006,0.166c0,0.547,0.095,0.882,0.287,1.004c0.191,0.122,0.713,0.184,1.566,0.184c0.665,0,1.09-0.071,1.273-0.212 c0.184-0.141,0.275-0.468,0.275-0.981c0-0.379-0.07-0.63-0.209-0.755c-0.139-0.124-0.441-0.2-0.904-0.227l-0.82-0.052 c-1.239-0.073-2.031-0.245-2.375-0.516c-0.344-0.271-0.516-0.855-0.516-1.75c0-0.914,0.208-1.523,0.623-1.827 c0.415-0.304,1.244-0.456,2.487-0.456c1.178,0,1.971,0.14,2.381,0.419c0.409,0.279,0.614,0.824,0.614,1.635V11.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M33.016,11.602c1.06,0,1.753,0.169,2.082,0.508c0.329,0.338,0.494,1.053,0.494,2.143 c0,1.216-0.161,2.014-0.482,2.392c-0.321,0.379-0.998,0.568-2.031,0.568c-1.121,0-1.846-0.176-2.177-0.528 c-0.331-0.352-0.496-1.126-0.496-2.323c0-1.151,0.162-1.899,0.487-2.243C31.219,11.774,31.927,11.602,33.016,11.602z  M33.005,12.64c-0.547,0-0.895,0.099-1.044,0.296c-0.149,0.197-0.224,0.657-0.224,1.38c0,0.826,0.071,1.342,0.212,1.549 c0.141,0.206,0.495,0.31,1.061,0.31c0.547,0,0.892-0.109,1.036-0.327c0.144-0.218,0.215-0.742,0.215-1.572 c0-0.7-0.074-1.147-0.224-1.342C33.888,12.738,33.544,12.64,33.005,12.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M38.002,9.319v7.831h-1.314V9.319H38.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M40.606,9.319v1.096h-1.314V9.319H40.606z M40.606,11.665v5.484h-1.314v-5.484H40.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M46.779,9.319v7.831H45.5l0.046-0.883l-0.023-0.006c-0.257,0.639-0.815,0.958-1.676,0.958 c-0.868,0-1.442-0.198-1.723-0.594c-0.282-0.396-0.422-1.2-0.422-2.412c0-0.979,0.151-1.659,0.454-2.039 c0.302-0.381,0.839-0.571,1.612-0.571c0.895,0,1.453,0.283,1.675,0.849l0.023-0.006V9.319H46.779z M44.203,12.64 c-0.49,0-0.807,0.104-0.952,0.313c-0.146,0.208-0.218,0.657-0.218,1.345c0,0.796,0.073,1.308,0.218,1.537 c0.145,0.23,0.47,0.344,0.975,0.344c0.528,0,0.866-0.113,1.013-0.339c0.147-0.226,0.221-0.746,0.221-1.561 c0-0.673-0.081-1.115-0.244-1.325C45.053,12.746,44.716,12.64,44.203,12.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M52.533,9.319v6.5h3.671v1.331h-5.158V9.319H52.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M58.281,13.254h-1.343c0-0.658,0.153-1.098,0.459-1.319c0.306-0.222,0.912-0.333,1.819-0.333 c0.987,0,1.654,0.136,2.002,0.407c0.348,0.271,0.522,0.79,0.522,1.555v3.585h-1.314l0.063-0.751l-0.035-0.006 c-0.253,0.547-0.836,0.821-1.75,0.821c-1.327,0-1.99-0.564-1.99-1.692c0-1.14,0.679-1.709,2.037-1.709 c0.906,0,1.457,0.209,1.652,0.625h0.023v-0.889c0-0.428-0.075-0.712-0.224-0.852c-0.149-0.14-0.455-0.209-0.918-0.209 C58.616,12.485,58.281,12.742,58.281,13.254z M59.159,14.694c-0.742,0-1.113,0.256-1.113,0.769c0,0.356,0.076,0.589,0.229,0.7 c0.153,0.111,0.475,0.166,0.964,0.166c0.799,0,1.199-0.27,1.199-0.809C60.438,14.969,60.012,14.694,59.159,14.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M63.048,17.149V9.319h1.314v3.132l0.029,0.011c0.226-0.578,0.797-0.866,1.715-0.866 c0.788,0,1.328,0.192,1.621,0.577c0.292,0.384,0.439,1.097,0.439,2.137c0,1.136-0.149,1.904-0.445,2.303 c-0.296,0.4-0.865,0.6-1.707,0.6c-0.853,0-1.413-0.31-1.681-0.929h-0.029l0.057,0.866H63.048z M65.659,12.635 c-0.853,0-1.279,0.53-1.279,1.589c0,0.83,0.073,1.362,0.218,1.598c0.146,0.235,0.475,0.353,0.987,0.353 c0.536,0,0.878-0.108,1.027-0.324c0.149-0.216,0.224-0.711,0.224-1.483c0-0.719-0.074-1.187-0.221-1.405 C66.467,12.744,66.148,12.635,65.659,12.635z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB0B2"
    },
    d: "M7.872,21.746c-0.256,0-0.512-0.06-0.747-0.181L0.922,18.38 c-0.545-0.28-0.888-0.841-0.888-1.454v-4.736l3.269,2.025v1.714l2.934,1.507v-3.092l-5.059-2.963 c-0.501-0.293-0.808-0.83-0.808-1.411V6.615c0-0.573,0.301-1.105,0.792-1.4l8.215-4.946 c0.518-0.312,1.166-0.312,1.684-0.001l8.802,5.281c0.657,0.394,0.71,1.169,0.71,1.919c0,0.75-0.034,3.232-0.034,3.232 l-3.41,1.357l-0.073-4.378l-6.835-4.101L3.639,7.539v1.492l5.059,2.963c0.501,0.293,0.808,0.83,0.808,1.411v6.706 c0,0.57-0.297,1.098-0.783,1.395C8.463,21.666,8.168,21.746,7.872,21.746z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "13.866,10.352 10.597,8.461 10.597,9.706 13.866,11.596  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M17.303,13.444v2.232l-3.437,2.033v-5.576l-3.269-1.89v10.287c0,0.583,0.31,1.122,0.815,1.414 c0.253,0.147,0.537,0.221,0.82,0.221c0.28,0,0.561-0.072,0.813-0.217l6.706-3.907c0.508-0.291,0.822-0.832,0.822-1.418v-4.52 L17.303,13.444z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "13.866,9.814 13.866,8.486 10.597,6.595 10.597,7.923  "
  })))))), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M21.18,3.802V2.231h-0.587v-0.21h1.412v0.21h-0.589v1.571H21.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M22.24,3.802V2.021h0.355l0.422,1.261c0.039,0.118,0.067,0.205,0.085,0.264 c0.02-0.065,0.052-0.16,0.095-0.285l0.426-1.239h0.317v1.781h-0.227V2.311l-0.518,1.491h-0.213l-0.515-1.516v1.516H22.24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1e071c1df534ae4fe7eba4d2ab10f521.svg";
export { ForwardRef as ReactComponent };